import { useState } from "react";
import { toast } from "react-toastify";
import { Button, FullScreenLoading, TextInput } from "src/Components";
import {
  IApplyOptionInsMarginConfig,
  IQueueStatusTableReport,
} from "src/Interfaces/applyOption";
import {
  setApplyOptionInstrumentMarginConfig
} from "src/Requests/applyOption";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  row: IQueueStatusTableReport;
  onClose: () => void;
}

const InsMarginConfig = ({ row, onClose }: IProps) => {
  const [formValues, setFormValues] = useState({
    callMargin: row.callMargin,
    insId: row.insId,
    instrumentName: row.instrumentName,
    putMargin: row.putMargin,
  } as IApplyOptionInsMarginConfig);
  const [loading, setLoading] = useState(false);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const submitHandler = () => {
    setLoading(true);
    setApplyOptionInstrumentMarginConfig(formValues)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onClose();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-start gap-2">
      {loading ? <FullScreenLoading /> : <></>}
      <TextInput
        label="حاشیه کال"
        value={formValues.callMargin?.toString()}
        name="callMargin"
        onChange={changeHandler}
        kind="negativeDecimalNumbers"
        extraLabel
      />
      <TextInput
        label="حاشیه پوت"
        value={formValues.putMargin?.toString()}
        name="putMargin"
        onChange={changeHandler}
        kind="negativeDecimalNumbers"
        extraLabel
      />
      <Button onClick={submitHandler} text="ثبت" variant="contained" />
    </div>
  );
};

export default InsMarginConfig;
